window.GifsAPI = new (function () {
    var self = this;

    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.GiphyServer );

    self.getGifsTrending = function (params) {
        var deferred = $q.defer();
        params = params || {};
        params['api_key'] = getGIFsKey();

        _protected.request(publicConfiguration.GiphyServer + 'gifs/trending', 'GET', params, true)
            .then(function (res) {
                if (res.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(`Error: ${res.status}`);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            })

        return deferred.promise;
    }

    self.getGifsSearch = function (params) {
        var deferred = $q.defer();
        params = params || {};
        params['api_key'] = getGIFsKey();

        _protected.request(publicConfiguration.GiphyServer + 'gifs/search', 'GET', params, true)
            .then(function (res) {
                if (res.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(`Error: ${res.status}`);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            })

        return deferred.promise;
    }

    self.getGifById = function (gifIf, params) {
        var deferred = $q.defer();
        params = params || {};
        params['api_key'] = getGIFsKey();

        _protected.request(publicConfiguration.GiphyServer + 'gifs/' + gifIf, 'GET', params, true)
            .then(function (res) {
                if (res.status === 200) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(`Error: ${res.status}`);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            })

        return deferred.promise;
    }

    var getGIFsKey = function () {
        if(environmentsConfig.getEnv().host === environmentsConfig.TEAM_SCHEDULE){
            return publicConfiguration.TsGiphyAPIKey;
        } else {
            return publicConfiguration.GiphyAPIKey;
        }
    }
});
